import { layout } from 'thewest/App.routing'

export const inCaseYouMissedItSegment = layout.nestedComposition({
    type: 'janus',
    props: {
        layoutRatio: '3:1',
        stretchColumns: true,
        verticalSpacing: 'xl',
    },
    contentAreas: {
        left: [
            layout.component({
                type: 'lima',
                props: {
                    fixedRatios: ['16:9'],
                    intermediateColumns: 3,
                    finalColumns: 3,
                    hideTeaser: false,
                    hideByline: false,
                    hasBackground: true,
                    cardLayout: [
                        ['teaserWithBackground'],
                        ['teaserWithBackground'],
                        [
                            {
                                type: 'landscape',
                                format: 'landscape-paddingNoKicker',
                            },
                            {
                                type: 'landscape',
                                format: 'landscape-paddingNoKicker',
                            },
                            {
                                type: 'landscape',
                                format: 'landscape-paddingNoKicker',
                            },
                        ],
                    ],
                    cardOrientation: { type: 'Landscape-Portrait' },
                    sectionHeader: {
                        heading: 'In Case You Missed It',
                        section: 'default',
                    },
                    dataDefinitionArgs: {
                        type: 'curation',
                        name: 'featured',
                        offset: 0,
                        pageSize: 5,
                    },
                },
            }),
        ],
        right: [
            layout.component({
                type: 'section-header',
                props: {
                    heading: 'Promotional',
                    hasMargin: true,
                    invisibleHeaderBreakpoint: 'md',
                },
            }),
            layout.component({
                type: 'promotional-card',
                props: {
                    cardOrientation: {
                        defaultLayout: 'landscape',
                        alternativeLayoutOptions: {
                            breakpoint: 'md',
                            layout: 'portrait',
                        },
                    },
                    fixedRatio: '4:3',
                    hasBackground: true,
                    hasPadding: true,
                    mediaMode: 'edgeToEdge',
                    fontScale: 0.88,
                    showCTA: true,
                    verticalSpacing: 'md',
                    dataDefinitionArgs: {
                        type: 'curation',
                        name: 'promotional-cards',
                        offset: 1,
                        pageSize: 1,
                    },
                },
            }),
        ],
    },
})
